export const FETCH_EMAILS = 'FETCH_EMAILS';
export const DELETE_EMAIL = 'DELETE_EMAIL';